import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Heart, Hand, Zap } from "lucide-react";

export const REACTION_ICONS = {
  heart: { Icon: Heart, color: "#FF007F", label: "Hartje" },
  clap: { Icon: Hand, color: "#FFD700", label: "Applaus" },
  wow: { Icon: Zap, color: "#00F0FF", label: "Wow" },
};

export function useReactionQueue() {
  const [items, setItems] = useState([]);
  const push = (kind) => {
    const id = `${Date.now()}-${Math.random()}`;
    const x = 5 + Math.random() * 90;
    setItems((prev) => [...prev.slice(-40), { id, kind, x }]);
    setTimeout(() => setItems((prev) => prev.filter((i) => i.id !== id)), 3500);
  };
  return { items, push };
}

export function ReactionsOverlay({ items }) {
  return (
    <div className="pointer-events-none fixed inset-0 z-30 overflow-hidden" data-testid="reactions-overlay">
      <AnimatePresence>
        {items.map((it) => {
          const { Icon, color } = REACTION_ICONS[it.kind] || REACTION_ICONS.heart;
          return (
            <motion.div key={it.id} data-testid={`reaction-${it.kind}`}
              initial={{ opacity: 0, y: 0, scale: 0.6 }}
              animate={{ opacity: [0, 1, 1, 0], y: -520, scale: [0.6, 1.2, 1, 0.9], x: [0, 20, -20, 0] }}
              exit={{ opacity: 0 }}
              transition={{ duration: 3.4, ease: "easeOut" }}
              style={{ position: "absolute", left: `${it.x}%`, bottom: 40, color }}>
              <Icon className="w-10 h-10 drop-shadow-[0_0_12px_currentColor]" fill={it.kind === "heart" ? color : "none"} />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}

export function useAnnouncer(lastNumber, enabled) {
  const prev = useRef(null);
  useEffect(() => {
    if (!enabled || lastNumber == null || lastNumber === prev.current) { prev.current = lastNumber; return; }
    prev.current = lastNumber;
    try {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(`Nummer ${lastNumber}`);
      u.lang = "nl-NL";
      u.rate = 0.9;
      const voice = window.speechSynthesis.getVoices().find((v) => v.lang.startsWith("nl"));
      if (voice) u.voice = voice;
      window.speechSynthesis.speak(u);
    } catch (e) { /* no speech support */ }
  }, [lastNumber, enabled]);
}
